export default "__VITE_ASSET__Bp6EnwRP__"